import React from 'react';

const PaperworkEntryTagList = ({ tags }) => {
    return (
        <ul className="tag">
            {
                tags.map(tag => {
                    return (
                        <li className="tag__item" key={tag}>
                            {tag}
                        </li>
                    )
                })
            }
        </ul>
    )
}

export { PaperworkEntryTagList }


// WEBPACK FOOTER //
// ./src/modules/paperwork-entry/components/PaperworkEntryTagList.js